import { useContext } from "react";
import { QuizContentContext } from "./Context";

export const useQuizContent = () => {
  const context = useContext(QuizContentContext);
  if (!context) {
    throw new Error('useQuizContent must be used within a QuizContentProvider');
  }
  return context;
};